import { Link } from "react-router-dom";

const ProductCard = ({
  imageSrc,
  title,
  subtitle,
  hrefrence,
  features = [],
  description = {},
  id,
}) => {

   // Function to check the length of the title and split if needed
   const splitTitle = (title) => {
    const words = title.split(" ");
    if (words.length > 3) {
      // Assuming the title is too long if it has more than 3 words
      return (
        <>
          {words.slice(0, 3).join(" ")} <br /> {words.slice(3).join(" ")}
        </>
      );
    }

    return title;
  };


  return (
    <div className="w-full m-2 md:w-[390px] pb-10 bg-white border h-auto md:h-[520px] border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
      <div className="w-full h-[190px] overflow-hidden rounded-t-lg flex items-center justify-center">
        <img
          className="object-contain w-full h-full"
          src={imageSrc}
          alt={title || "Product image"}
        />
      </div>

      <div className="pt-5 flex flex-col justify-evenly h-[400px] ">
        <div className="px-5 md:px-10 h-1/3">
          {title && (
            <p className="mb-2 text-[18px] md:text-[20px] font-bold text-left tracking-tight text-gray-900 dark:text-white line-clamp-2">
              {splitTitle(title)}
            </p>
          )}
          {subtitle && (
            <div className="mb-3 text-[12px] md:text-[14px] text-left font-normal text-gray-700 dark:text-gray-400">
              {subtitle}
            </div>
          )}
        </div>
        {features.length > 0 && (
          <>
            <hr className="border-[#CCCCCC] border-t-2" />
            <div className="mx-5 md:mx-10 h-1/3">
              <ul className="max-w-md mt-5 space-y-1 text-gray-500 list-inside dark:text-gray-400 text-[10px] md:text-[12px]">
                {features.slice(0, 2).map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <svg
                      className="mt-0.5 w-2.5 h-2.5 mr-2 text-gray-500 dark:text-gray-400 flex-shrink-0"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span className="line-clamp-2">{feature}</span>
                  </li>
                ))}
                {features.length > 2 && (
                  <li className="flex items-start">
                    <svg
                      className="mt-0.5 w-2.5 h-2.5 mr-2 text-gray-500 dark:text-gray-400 flex-shrink-0"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    {`+${features.length - 2} more`}
                  </li>
                )}
              </ul>
            </div>
          </>
        )}

        <br/>
            <hr className="border-[#CCCCCC] border-t-2" />

        <div className="h-1/3 ">
        <div className="px-5 md:px-10 mt-2 hover:bg-gray-300">
          <Link
            to={`/productdetails/${id}`}
            className="text-[#005CB9] text-center font-bold text-lg md:text-xl "  
          >
            <p>
              View Product 
              {/* <i className="fa-solid fa-arrow-right"></i> */}
            </p>
          </Link>
        </div>
        </div>

      </div>
    </div>
  );
};

export default ProductCard;
